import { HOME } from '@/constants/testIds';
import { Filter, X } from 'lucide-react';

export default function FilterSidebar({
  filters,
  setFilters,
  books,
  onClear,
}) {
  const update = (k, v) => setFilters((f) => ({ ...f, [k]: v, page: 1 }));

  return (
    <aside className="bg-white border border-slate-200 rounded-xl p-6 lg:p-7 h-fit sticky top-20">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Filter className="w-4 h-4 text-slate-600" strokeWidth={2} />
          <h3 className="font-semibold text-slate-900 text-sm tracking-wider uppercase">
            Filters
          </h3>
        </div>
        <button
          onClick={onClear}
          data-testid={HOME.filterClear}
          className="text-xs text-slate-500 hover:text-[#1E3A8A] flex items-center gap-1"
        >
          <X className="w-3 h-3" /> Reset
        </button>
      </div>

      <div className="space-y-6">
        <div>
          <label className="block text-xs font-semibold uppercase tracking-[0.15em] text-slate-500 mb-2">
            Testament
          </label>
          <div className="grid grid-cols-3 gap-1.5">
            {['all', 'Old', 'New'].map((t) => (
              <button
                key={t}
                data-testid={`${HOME.filterTestament}-${t}`}
                onClick={() => update('testament', t)}
                className={`px-2 py-2 text-xs rounded-md border transition-all ${
                  filters.testament === t
                    ? 'bg-[#1E3A8A] text-white border-[#1E3A8A]'
                    : 'bg-white text-slate-700 border-slate-200 hover:border-slate-400'
                }`}
              >
                {t === 'all' ? 'All' : t === 'Old' ? 'Old T.' : 'New T.'}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-xs font-semibold uppercase tracking-[0.15em] text-slate-500 mb-2">
            Importance
          </label>
          <div className="grid grid-cols-3 gap-1.5">
            {['all', 'Major', 'Minor'].map((t) => (
              <button
                key={t}
                data-testid={`${HOME.filterImportance}-${t}`}
                onClick={() => update('importance', t)}
                className={`px-2 py-2 text-xs rounded-md border transition-all ${
                  filters.importance === t
                    ? 'bg-[#0F766E] text-white border-[#0F766E]'
                    : 'bg-white text-slate-700 border-slate-200 hover:border-slate-400'
                }`}
              >
                {t === 'all' ? 'All' : t}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-xs font-semibold uppercase tracking-[0.15em] text-slate-500 mb-2">
            Book
          </label>
          <select
            data-testid={HOME.filterBook}
            value={filters.book}
            onChange={(e) => update('book', e.target.value)}
            className="input-base text-sm py-2.5"
          >
            <option value="all">All books</option>
            {books.map((b) => (
              <option key={b.book} value={b.book}>
                {b.book} ({b.count})
              </option>
            ))}
          </select>
        </div>
      </div>
    </aside>
  );
}
